import React, { useEffect, useState } from "react";
import { CaseStudy_IMAGES_API } from "../../../../../../Utilities/APIs";
import Form from "../../../../../Partials/Layouts/Forms/Form";
import ImageInput from "../../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import VideoInput from "../../../../../Partials/Layouts/Forms/FormInputs/VideoInput/VideoInput";

function UpdateCaseStudyImage({
  targetID,
  triggerFetch,
  setShowUpdateForm,
  setShowModal,
  CaseStudyId,
}) {
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetCaseStudyInfo() {
      const { data } = await axiosInstance.get(CaseStudy_IMAGES_API + targetID);
      setImage(data.image);
      setVideo(data.video);
    }
    fetchAndSetCaseStudyInfo();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();
    itemData.append("image", image);
    itemData.append("video", video);
    itemData.append("CaseStudyId", CaseStudyId);

    const response = await axiosInstance.patch(
      CaseStudy_IMAGES_API + targetID,
      itemData
    );

    if (response) {
      setShowUpdateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ImageInput
        fieldId="1"
        state={image}
        setState={setImage}
        allowUpdateImage
      >
        Upload Card Image
      </ImageInput>

      <VideoInput
        fieldId="2"
        state={video}
        setState={setVideo}
        allowUpdateImage
      >
        Upload Video
      </VideoInput>
      <FormSubmitButton text="Update" />
    </Form>
  );
}
export default UpdateCaseStudyImage;
